import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["textContent"]

import { computed, PropType } from "vue";
import { TaskModel } from "@/components/tasks-kanban/models";
import { ListItemModel } from "../../../models";
import { TaskCardItemWrapper } from "./";
import { TaskParameter, TaskParameterTypeEnum } from "@/components/task-parameter";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-card-tags',
  props: {
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
},
  setup(__props) {

const props = __props;



/**Первый тег */
const firstTag = computed(() => props.task.Tags?.[0]);
/**Скрытые тэги */
const hiddenTags = computed(() => Math.max(props.task.Tags.length - 1, 0));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TaskCardItemWrapper), { element: __props.element }, {
    default: _withCtx(() => [
      (firstTag.value)
        ? (_openBlock(), _createBlock(_unref(TaskParameter), {
            key: 0,
            preview: "",
            data: firstTag.value,
            type: _unref(TaskParameterTypeEnum).Tag
          }, null, 8, ["data", "type"]))
        : _createCommentVNode("", true),
      (hiddenTags.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            textContent: _toDisplayString(`+${hiddenTags.value}`),
            class: "task-card_circle"
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["element"]))
}
}

})